import type { SVGProps } from 'react';

const SvgRankingOne = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={32}
    viewBox='0 0 32 32'
    width={32}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M24 27.333h-1.333V27c0-1.467-1.2-2.667-2.667-2.667h-3V21.28c-.333.04-.667.053-1 .053s-.667-.013-1-.053v3.053h-3A2.674 2.674 0 0 0 9.333 27v.333H8c-.547 0-1 .454-1 1 0 .547.453 1 1 1h16c.547 0 1-.453 1-1s-.453-1-1-1M7.36 15.52c-.88-.333-1.653-.88-2.267-1.493-1.24-1.374-2.053-3.014-2.053-4.934a3.39 3.39 0 0 1 3.427-3.426h.746A5.3 5.3 0 0 0 6.667 8v4c0 1.253.24 2.44.693 3.52M28.96 9.093c0 1.92-.813 3.56-2.053 4.934-.613.613-1.387 1.16-2.267 1.493a9.1 9.1 0 0 0 .694-3.52V8c0-.84-.2-1.627-.547-2.333h.747a3.39 3.39 0 0 1 3.426 3.426'
      fill='#FF7C00'
    />
    <path
      d='M20 2.667h-8A5.33 5.33 0 0 0 6.667 8v4A9.326 9.326 0 0 0 16 21.333 9.327 9.327 0 0 0 25.333 12V8A5.33 5.33 0 0 0 20 2.667'
      fill='#FFC500'
    />
    <g filter='url(#ranking-one)'>
      <path d='M17.064 16h-1.623V9.753h-.043l-1.785 1.118v-1.43l1.925-1.226h1.526z' fill='#fff' />
    </g>
    <defs>
      <filter
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
        height={13.118}
        id='ranking-one'
        width={8.785}
        x={10.946}
        y={5.549}
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1.333} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.988235 0 0 0 0 0.545098 0 0 0 0 0 0 0 0 1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_443_32124' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_443_32124' result='shape' />
      </filter>
    </defs>
  </svg>
);
export default SvgRankingOne;
